import React from 'react';
import styles from './announcements.module.scss';
export default function CustomerAnnouncements() {
  return (
    <div className={styles.wrapper}>Announcements</div>
  );
}
